var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { LinkText } from 'ilenia';
import { Flex, Box } from '../../CommonUI/Layout';
export var Checkbox = function (props) {
    var id = props.id, label = props.label, onLabelClick = props.onLabelClick, links = props.links, disabled = props.disabled, interpolations = props.interpolations, rest = __rest(props, ["id", "label", "onLabelClick", "links", "disabled", "interpolations"]);
    return (React.createElement(Box, { mt: 10, pr: 20 },
        React.createElement(Flex, { flexDirection: "row-reversed", alignItems: "center", className: css(styles.control) },
            React.createElement("div", { className: css(styles.checkboxWrapper) },
                React.createElement("input", __assign({ type: "checkbox", className: css(styles.checkbox), id: id, disabled: disabled }, rest))),
            React.createElement("label", { htmlFor: id, className: css(styles.label), onClick: onLabelClick },
                React.createElement(LinkText, { id: label, links: __spreadArrays(links), interpolations: interpolations })))));
};
var styles = StyleSheet.create({
    control: {
        'display': 'block',
        'textAlign': 'left',
        'marginBottom': '0.5rem',
        'text-size-adjust': '100%',
        '-webkit-font-smoothing': 'antialiased',
        'font-family': 'TrustpilotDefaultFont, Arial, sans-serif',
        '-webkit-appearance': 'checkbox',
    },
    checkboxWrapper: {
        width: '14px',
        height: '14px',
        alignSelf: 'flex-start',
    },
    checkbox: {
        width: '14px',
        height: '14px',
        fontSize: '16px',
        outline: 'none',
        backgroundColor: 'initial',
        boxSizing: 'border-box',
        margin: '0',
        display: 'block',
        lineHeight: '24px',
    },
    label: {
        boxSizing: 'content-box',
        color: 'rgb(69, 69, 84);',
        cursor: 'pointer',
        userSelect: 'none',
        lineHeight: '1.43',
        marginLeft: '9px',
        display: 'inline-block',
        fontSize: '12px',
        fontStyle: 'normal',
        position: 'relative',
        textAlign: 'left',
        fontWeight: 400,
    },
});
